/** Suggested Lucide icon names — admin picks one from this curated list. */
export const SHEET_ICONS = [
    'Table2',
    'Sheet',
    'Database',
    'LineChart',
    'BarChart3',
    'PieChart',
    'Calculator',
    'ClipboardList',
    'BookOpen',
    'Briefcase',
];
//# sourceMappingURL=sheet.js.map